"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "colorType", "className"];
var Label = function Label(_ref) {
  var children = _ref.children,
    colorType = _ref.colorType,
    className = _ref.className,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefixCls = 'ykb-ui-label';
  var cls = (0, _classnames2.default)(prefixCls, className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "--").concat(colorType), colorType));
  console.log('This component is deprecated and will be removed in upcoming releases. Check Typography component for related needs please.');
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: cls
  }, rest), children);
};
Label.propTypes = {
  colorType: _propTypes.default.oneOf(['primary', 'secondary', 'default', 'success', 'warning', 'danger'])
};
Label.defaultProps = {
  colorType: null
};
var _default = exports.default = Label;